import React, { useState } from "react";
import { Box, Container, Flex } from "@chakra-ui/react";
import HomeVideo from "../../../assets/HomePageVideo.mp4"

const VideoPlayer = () => {
  const [videoUrl, setVideoUrl] = useState(false);
  return (
    <Container width={"100%"} alignContent={"center"} mt="10px">
      <video controls width={"100%"}>
        <source
          src={HomeVideo}
          type="video/mp4"
        />
        Your browser does not support the video tag.
      </video>
    </Container>
  );
};

export default VideoPlayer;
